import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Star } from "lucide-react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";
import api from "@/lib/api";

const INCLUDED = ["Slang, emoji & behaviour decoders", "Up to 5 child profiles", "Save & organise your decode deck", "Warning-sign checklists always free", "Everything encrypted & private"];

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/config/plans").then(({ data }) => setPlans(data.plans)).catch(() => {}); }, []);

  return (
    <div>
      <PublicNav />
      <section className="dk-container py-16">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="badge-soft mb-3">Pricing</span>
          <h1 className="text-[32px] sm:text-[40px] font-semibold">Start free. Pay only if it helps.</h1>
          <p className="mt-3 text-[18px]" style={{ color: "var(--text-muted)" }}>Every plan includes the full toolkit and up to 5 child profiles. Begin with a free 3-day trial — no card needed.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {plans.map((p) => (
            <div key={p.id} className={`dk-card p-6 space-y-4 relative ${p.popular ? "ring-2" : ""}`} style={p.popular ? { borderColor: "var(--accent)", boxShadow: "0 8px 30px -6px rgba(200,90,72,.2)" } : {}} data-testid="pricing-plan-card">
              {p.popular && <span className="badge-soft absolute -top-3 left-6" style={{ background: "var(--accent-strong)", color: "#fff" }}><Star size={12} /> Most popular</span>}
              <h3 className="font-serif text-[22px] font-medium">{p.name}</h3>
              <div className="flex items-end gap-1">
                <span className="font-serif text-[40px] font-semibold">₹{p.price}</span>
                <span className="mb-2 text-sm" style={{ color: "var(--text-muted)" }}>/ {p.interval}</span>
              </div>
              <p className="text-sm" style={{ color: "var(--text-muted)" }}>{p.note}</p>
              <button className={`btn w-full ${p.popular ? "btn-primary" : "btn-outline"}`} onClick={() => nav("/auth/signup")} data-testid={`pricing-choose-${p.id}`}>Start free trial</button>
            </div>
          ))}
        </div>

        <div className="dk-card p-8 mt-10 max-w-3xl mx-auto">
          <h3 className="font-serif text-[20px] font-medium mb-4">Every plan includes</h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {INCLUDED.map((i) => (
              <div key={i} className="flex items-center gap-2 text-sm"><Check size={16} style={{ color: "var(--success)" }} /> {i}</div>
            ))}
          </div>
          <p className="text-xs mt-6" style={{ color: "var(--text-muted)" }}>
            Payments are final. Cancel any time to stop renewal — your access continues to the end of the paid period. Where your country's law gives a right to a refund, it is honoured. Prices shown in INR.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
